import React, { useEffect, useState, useContext } from 'react';
import { DialogAction, useModal } from '../../../../../function/useModal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@material-ui/core';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../../atoms/Dialog/MessageDialog';
import { SettingsState } from '../../../../organisms/SelectSettings';
import { NAME_DEV_SET, GetNameDevSetRow, SetNameDevSetRow } from '../../../../../function/NameDevSetModel';
import { ErrorCode } from '../../../../../ErrorCode';
import { AppContext } from '../../../../../App';
import { FFT_MAX_VALUE_CLUDO, FFT_MAX_VALUE_ONPRE } from '../../../../../Constant';

import { DeviceRegistPageStyle, TableBaseStyle } from './../DeviceRegistStyle';
import VibrationSettingDialogBody from './VibrationSettingDialogBody';


export type VibrationSettingDialogProps = {
  editData: SettingsState;
};

export type VibrationSettingDialogResponse = {};


const VibrationSettingDialog: React.FC<VibrationSettingDialogProps> = (props: VibrationSettingDialogProps) => {
  const { t } = useTranslation();
  const pageStyle = DeviceRegistPageStyle();

  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [isUpdateDisp, setIsUpdateDisp] = useState<boolean>(false);
  const [devRow, setDevRow] = useState<NAME_DEV_SET>({
    DEV_INDEX: 0,
    EST: 0,
    DEV_NO: '',
    DEV_NAME: '',
    FLG_MOTOR: 0,
    REV_VAL: 0,
    RATED_CUR: 0,
    BEARING_LD: '',
    BEARING_ANTI_LD: '',
    RATED_SPEED: 0,
    RATED_POWER: 0,
    POLE: 0,
    VOLTAGE: 0,
    PWR_FREQ: 0,
    EXC_CUR: 0,
    INV_FREQ: 0,
    WEALTH: 0,
    START_JDG_CUR: 0,
    NOTE: '',
    CAREER_MASK: 0,
    WAV_MAKE: 0,
    INV_DRV_ON: 0,
    EMC_TYPE: 0,
    SMOOTH_W0: 0,
    SMOOTH_W1: 0,
    SMOOTH_W2: 0,
    TH_SIGMA: 0,
    TH_L_R: 0,
    TH_L_S: 0,
    TH_L_T: 0,
    TH_H_R: 0,
    TH_H_S: 0,
    TH_H_T: 0,
    SPD_UP_FREQ: 0,
    SPD_LO_FREQ: 0,
    DSP_UP_FREQ: 0,
    DSP_LO_FREQ: 0,
    startJdgCurPer: 0,
  });

  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const { login } = useContext(AppContext);

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('CollectSetting.はい', 'はい')}
      cancel={t('CollectSetting.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    /** 初期設定 */
    // setDevNo(1);
    // setItemName(1);
  }, []);

  /**
   * NAME_DEV_SETテーブルからデータを取得
   */
  useEffect(() => {
    setButtonEnable(false);
    GetNameDevSetRow(props.editData.selectIndexNo !== undefined ? props.editData.selectIndexNo : 0)
      .then((res) => {
        if (res !== undefined) {
          setDevRow(res);
          console.debug(['GetNameDevSetRow check', res]);
        }
        props.editData.IsUpdate = false;
        setButtonEnable(true);
      })
      .catch((e) => {
        setDlgmsg(t('VibrationSettingDialog.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
      })
      .finally(() => {
        setButtonEnable(true);
      });
  }, []);

  /**
   * タブ遷移時の保存
   */
  useEffect(() => {
    props.editData.SaveFunction = saveAction2;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);

  /**
  * NAME_DEV_SETの更新処理
  * @param item
  */
  const updateDev = (item: NAME_DEV_SET) => {
    if (item.DEV_INDEX === devRow.DEV_INDEX) {
      setDevRow(item);
      props.editData.Target = item;
      props.editData.IsUpdate = true;
    }
  };

  /**
   * キャンセル処理
   */
  const cancelAction = () => {
    //編集済みの場合確認する
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'VibrationSettingDialog.保存していないデータを破棄しますよろしいですか',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          props.editData.IsUpdate = false;
          console.debug(t('VibrationSettingDialog.実行', '実行'));

          if (props.editData.CloseDialog !== undefined) {
            console.debug('VibrationSettingDialog closeAction complete');
            props.editData.CloseDialog();
          }
          else {
            console.debug('VibrationSettingDialog closeAction failuer');
          }
        })
        .cancel(() => {
          console.debug(t('VibrationSettingDialog.キャンセル', 'キャンセル'));
        });
    } else {
      if (props.editData.CloseDialog !== undefined) {
        console.debug('VibrationSettingDialog closeAction complete');
        props.editData.CloseDialog();
      }
      else {
        console.debug('VibrationSettingDialog closeAction failuer');
      }
    }
  };

  /**
   * 保存処理
   */
  const saveAction = () => {
    //未編修なら実行しない
    if (props.editData.IsUpdate === false) {
      console.debug("VibrationSettingDialog not edited");
      return;
    }

    //保存前チェック
    if (!checkInputData(devRow)) {
      return;
    }

    setDlgmsg(t('VibrationSettingDialog.保存しますか?', '保存しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        setButtonEnable(false);
        saveProc(devRow).finally(() => {
          setButtonEnable(true);
        });
      })
      .cancel(() => { });
  }

  /**
   * 保存
   */
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const devItem = target as NAME_DEV_SET;
      if (devItem) {
        SetNameDevSetRow(devRow)
          .then((res) => {
            console.debug(`VibrationSettingDialog SetNameDevSetRow res : ${res}`);
            //保存完了後にダイアログを閉じるか確認
            if (res.ErrorCode == ErrorCode.ERR_CODE_NONE) {
              props.editData.IsUpdate = false;
              setIsUpdateDisp(!isUpdateDisp);
              setDlgmsg(t('VibrationSettingDialog.保存が完了しました\nダイアログを閉じますか', '保存が完了しました\nダイアログを閉じますか'));
              actCfmDlg
                .open()
                .apply((_) => {
                  props.editData.IsUpdate = false;
                  console.debug(t('VibrationSettingDialog.実行', '実行'));

                  if (props.editData.CloseDialog !== undefined) {
                    console.debug('VibrationSettingDialog closeAction complete');
                    props.editData.CloseDialog();
                  }
                  else {
                    console.debug('VibrationSettingDialog closeAction failuer');
                  }
                })
                .cancel(() => {
                  console.debug(t('VibrationSettingDialog.キャンセル', 'キャンセル'));
                });

              // props.editData.CloseSetting();
              resolve('done');
            } else {
              setDlgmsg(t('LayerShortSettingDialog.周波数範囲設定の保存に失敗しました', '周波数範囲設定の保存に失敗しました'));
              actMsgDlg.open();
              console.error(['LayerShortSettingDialog save failed']);
              reject('update fault');
            }
          })
          .catch((error) => {
            console.error('VibrationSettingDialog SetNameDevSetRow : ' + error);
          });
      } else {
        reject('data error');
      }
    })
  }

  /**
   * タブ遷移時の保存処理
   * @param param 
   * @returns 
   */
  const saveAction2 = (param: object): Promise<string> => {
    console.debug(["--VibrationSettingDialog saveAction2 strat--"]);

    return new Promise((resolve, reject) => {
      const devItem = param as NAME_DEV_SET;
      //保存前チェック
      if (!checkInputData(devItem)) {
        return;
      }
      //console.debug(["--sp--", sp]);
      setButtonEnable(false);

      SetNameDevSetRow(devItem)
        .then((r) => {
          props.editData.IsUpdate = false;
          console.debug('saveAction ok');
          resolve('done');

        })
        .catch((r) => {
          setDlgmsg(t('VibrationSettingDialog.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
          actMsgDlg.open();
          console.error(['saveAction error', r]);
          reject('data error');
        })
        .finally(() => {
          setButtonEnable(true);
        });

    })
  }

  /**
   * 下限周波数 < 上限周波数か確認
   * @returns 
   */
  const checkInputData = (nameDevRow: NAME_DEV_SET): boolean => {
    console.debug("VibrationSettingDialog input check Start", nameDevRow);
    let maxValue = login.IsIoT ? FFT_MAX_VALUE_CLUDO : FFT_MAX_VALUE_ONPRE;

    //振動(速度)
    console.debug("devRow.SPD_LO_FREQ < devRow.SPD_UP_FREQ check", nameDevRow.SPD_LO_FREQ, nameDevRow.SPD_UP_FREQ);
    if (nameDevRow.SPD_LO_FREQ === null) {
      setDlgmsg(t('VibrationSettingDialog.振動速度で下限周波数の値が空です\n値を入力してください', '振動(速度)で下限周波数の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("VibrationSettingDialog input check NG");
      return false;
    }
    else if (nameDevRow.SPD_UP_FREQ === null) {
      setDlgmsg(t('VibrationSettingDialog.振動速度で上限周波数の値が空です\n値を入力してください', '振動(速度)で上限周波数の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("VibrationSettingDialog input check NG");
      return false;
    }
    else {
      //DBで直接値を変更された場合のチェック
      if (nameDevRow.SPD_LO_FREQ < 1) {
        setDlgmsg(t('VibrationSettingDialog.振動速度の下限周波数の値が最小値より小さいです', '振動(速度)の下限周波数の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog SPD_LO_FREQ < minValue");
        return false;
      }
      else if (nameDevRow.SPD_LO_FREQ > maxValue) {
        setDlgmsg(t('VibrationSettingDialog.振動速度の下限周波数の値が最大値より大きいです', '振動(速度)の下限周波数の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog SPD_LO_FREQ > maxValue");
        return false;
      }

      if (nameDevRow.SPD_UP_FREQ < 1) {
        setDlgmsg(t('VibrationSettingDialog.振動速度の上限周波数の値が最小値より小さいです', '振動(速度)の上限周波数の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog SPD_UP_FREQ < minValue");
        return false;
      }
      else if (nameDevRow.SPD_UP_FREQ > maxValue) {
        setDlgmsg(t('VibrationSettingDialog.振動速度の上限周波数の値が最大値より大きいです', '振動(速度)の上限周波数の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog SPD_UP_FREQ > maxValue");
        return false;
      }

      if (nameDevRow.SPD_LO_FREQ >= nameDevRow.SPD_UP_FREQ) {
        setDlgmsg(t('VibrationSettingDialog.振動速度で下限周波数が上限周波数より大きいです', '振動(速度)で下限周波数が上限周波数より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog input check NG");
        return false;
      }
    }

    //振動(変位)
    console.debug("devRow.DSP_LO_FREQ < devRow.DSP_UP_FREQ check", nameDevRow.DSP_LO_FREQ, nameDevRow.DSP_UP_FREQ);
    if (nameDevRow.DSP_LO_FREQ === null) {
      setDlgmsg(t('VibrationSettingDialog.振動変位で下限周波数の値が空です\n値を入力してください', '振動(変位)で下限周波数の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("VibrationSettingDialog input check NG");
      return false;
    }
    else if (nameDevRow.DSP_UP_FREQ === null) {
      setDlgmsg(t('VibrationSettingDialog.振動変位で上限周波数の値が空です\n値を入力してください', '振動(変位)で上限周波数の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("VibrationSettingDialog input check NG");
      return false;
    }
    else {
      if (nameDevRow.DSP_LO_FREQ < 1) {
        setDlgmsg(t('VibrationSettingDialog.振動変位の下限周波数の値が最小値より小さいです', '振動(変位)の下限周波数の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog DSP_LO_FREQ < minValue");
        return false;
      }
      else if (nameDevRow.DSP_LO_FREQ > maxValue) {
        setDlgmsg(t('VibrationSettingDialog.振動変位の下限周波数の値が最大値より大きいです', '振動(変位)の下限周波数の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog DSP_LO_FREQ > maxValue");
        return false;
      }

      if (nameDevRow.DSP_UP_FREQ < 1) {
        setDlgmsg(t('VibrationSettingDialog.振動変位の上限周波数の値が最小値より小さいです', '振動(変位)の上限周波数の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog DSP_UP_FREQ < minValue");
        return false;
      }
      else if (nameDevRow.DSP_UP_FREQ > maxValue) {
        setDlgmsg(t('VibrationSettingDialog.振動変位の上限周波数の値が最大値より大きいです', '振動(変位)の上限周波数の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog DSP_UP_FREQ > maxValue");
        return false;
      }

      if (nameDevRow.DSP_LO_FREQ >= nameDevRow.DSP_UP_FREQ) {
        setDlgmsg(t('VibrationSettingDialog.振動変位で下限周波数が上限周波数より大きいです', '振動(変位)で下限周波数が上限周波数より大きいです'));
        actMsgDlg.open();
        console.warn("VibrationSettingDialog input check NG");
        return false;
      }
    }

    return true;
  }

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          {/**ボディーの呼び出し処理 */}
          {devRow.DEV_INDEX !== 0 ?
            <VibrationSettingDialogBody
              nameDevSetRow={devRow}
              updateItem={updateDev}
            /> :
            null
          }
          {/** 上の項目と引き離す処理 */}
          <div style={{ margin: '230px 0' }} />
        </Grid>
      </Grid>

      <DialogActions>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => {
            saveAction();
          }}
        >
          {t('VibrationSettingDialog.保存', '保存')}
        </Button>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => {
            cancelAction();
          }}
        >
          {t('VibrationSettingDialog.キャンセル', 'キャンセル')}
        </Button>
      </DialogActions>
      {cfmdlg}
      {msgdlg}
    </>
  )
}

export default VibrationSettingDialog;


